/**
 * Custom element para Load More e Infinite Scroll
 * Uso: <wrapp-hdt-lm-main-url render-on-scroll section-id="..." append="...">
 */
class LoadMoreWrapper extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.loading = false;
  }

  connectedCallback() {
    const link = this.querySelector('a');
    if (!link) return;

    // Si tiene render-on-scroll, activar infinite scroll
    if (this.hasAttribute('render-on-scroll')) {
      this.initInfiniteScroll(link);
    } else {
      // Si no, es load more manual
      this.initLoadMore(link);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initInfiniteScroll(link) {
    // Ocultar el botón
    link.style.display = 'none';

    // Crear observer para detectar cuando el usuario llega al final
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loading) {
          this.loadMore(link.href);
        }
      });
    }, {
      rootMargin: '400px' // Cargar cuando falten 400px para llegar
    });

    this.observer.observe(this);
  }

  initLoadMore(link) {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (!this.loading) {
        this.loadMore(link.href);
      }
    });
  }

  async loadMore(url) {
    if (this.loading) return;
    
    this.loading = true;
    const sectionId = this.getAttribute('section-id');
    const appendId = this.getAttribute('append');
    const isPrepend = this.hasAttribute('prepend');

    // Mostrar loading
    this.classList.add('loading');
    const link = this.querySelector('a');
    const originalText = link.innerHTML;
    link.innerHTML = '<span>Cargando...</span>';

    try {
      // Fetch de la siguiente página
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Encontrar el contenedor de productos
      const newProductsContainer = doc.querySelector(`#${appendId}`);
      const currentProductsContainer = document.querySelector(`#${appendId}`);

      if (!newProductsContainer || !currentProductsContainer) {
        console.error('No se encontró el contenedor de productos');
        return;
      }

      // Obtener los nuevos productos
      const newProducts = newProductsContainer.children;

      // Insertar productos
      if (isPrepend) {
        // Insertar al principio
        Array.from(newProducts).reverse().forEach(product => {
          currentProductsContainer.insertBefore(product.cloneNode(true), currentProductsContainer.firstChild);
        });
      } else {
        // Insertar al final
        Array.from(newProducts).forEach(product => {
          currentProductsContainer.appendChild(product.cloneNode(true));
        });
      }

      // Trigger evento para Globo Filter y otras apps
      currentProductsContainer.dispatchEvent(new CustomEvent('products:loaded', {
        bubbles: true,
        detail: { products: newProducts }
      }));

      // Actualizar el link para la siguiente página
      const newPaginationWrapper = doc.querySelector('wrapp-hdt-lm-main-url');
      
      if (newPaginationWrapper) {
        const newLink = newPaginationWrapper.querySelector('a');
        if (newLink) {
          link.href = newLink.href;
          link.innerHTML = originalText;
        } else {
          // No hay más páginas
          this.remove();
        }
      } else {
        // No hay más páginas
        this.remove();
      }

    } catch (error) {
      console.error('Error cargando más productos:', error);
      link.innerHTML = originalText;
    } finally {
      this.loading = false;
      this.classList.remove('loading');
    }
  }
}

// Registrar el custom element
if (!customElements.get('wrapp-hdt-lm-main-url')) {
  customElements.define('wrapp-hdt-lm-main-url', LoadMoreWrapper);
}